import React from 'react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { getCurrencySymbol, getPositiveSum } from '../../../../helpers';
import moment from 'moment';

const Wrapper = styled('tr')`
  font-size: 14px;
  strong {
    display: block;
    color: #323a46;
  }

  td {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .link {
    display: block;
    color: #323a46;
    font-size: 14px;
  }
`;

const TableRow = (props) => {
  const { item, urlSearchStr, t = null } = props;
  return (
    <>
      <Wrapper>
        <td>
          <span className="text-muted">{moment(item.date).format('DD.MM.YYYY')}</span>
        </td>
        <td>
          {item.items?.length ? (
            <Link
              className="link"
              to={{
                pathname: `/finances/${item.id}`,
                state: {
                  customBackLink: urlSearchStr ? '/finances' + urlSearchStr : null,
                },
              }}
            >
              {item.title}
              {item.description && (
                <span className="text-muted d-block font-13">
                  {t ? t(item.description) : item.description}
                </span>
              )}
            </Link>
          ) : (
            <>
              {item.title}
              {item.description && (
                <span className="text-muted d-block font-13">
                  {t ? t(item.description) : item.description}
                </span>
              )}
            </>
          )}
        </td>
        <td align="right">
          <strong>{`${getPositiveSum(+item.totalSum)} ${getCurrencySymbol('RUB')}`}</strong>
        </td>
        <td></td>
      </Wrapper>
    </>
  );
};

export default TableRow;
